import { render } from "./device-switch.vue?vue&type=template&id=bbaca726&scoped=true"
import script from "./device-switch.vue?vue&type=script&lang=js"
export * from "./device-switch.vue?vue&type=script&lang=js"

import "./device-switch.vue?vue&type=style&index=0&id=bbaca726&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbaca726"]])

export default __exports__